<template>
  <div class="card vld-parent" style="margin: auto;">
    <div style="margin: auto; width: 100%; text-align: center;">
      <loading
        :active.sync="isLoading"
        :can-cancel="canCancel"
        :is-full-page="fullPage"
        :height="height"
        :width="width"
        :color="color"
        :loader="loader"
        :background-color="bgColor"
      >
        <div v-if="useSlot">
            <img v-show="forConasi" id="loading" src="../assets/e_voucher_logo.png" width="224px" />
            <img v-show="!forConasi" id="loading" src="../assets/e_voucher_logo.svg" width="224px" />
            <h5 id="loading">{{ $t('common.loading') }} ...</h5>
        </div>
      </loading>
    </div>
  </div>
</template>

<script>
import Loading from "../lib/index";
import { FOR_CONASI_TARGET } from 'Utils/constants'
export default {
  props: {
    isLoading: {
      type: Boolean,
      default: () => false,
    },
    useSlot: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      fullPage: true,
      canCancel: false,
      loader: "bars",
      color: "#007bff",
      bgColor: "#ffffff",
      height: 128,
      width: 128,
      timeout: 3000, //ms
      forConasi: FOR_CONASI_TARGET
    };
  },
  components: {
    Loading,
  },
};
</script>
<style lang="scss" scoped>
#loading {
  animation: rotate 1s linear infinite;
}
@keyframes rotate {
  20% {
    transform: rotateY(0deg)
  }
  40% {
    transform: rotateY(90deg)
  }
  60% {
    transform: rotateY(270deg)
  }
  100% {
    transform: rotateY(360deg)
  }
}
</style>